<template>
    <v-container class="pa-0 pb-16">
        <v-card elevation="0" :rounded="$vuetify.display.lgAndUp ? 'lg' : false">
            <product-quick-detail
                class="px-0 py-5 pa-lg-10 pb-0"
                :product="product"
                :add-value="toAdd"
                :time="expedition"
                :compute="!navigation"
                :navigation="navigation"
                :is-modal="!!navigation"
                @selected-variant="variant = $event"
                @to-add="toAdd = $event"
                @close="emit('close')"
                @change-index="emit('changeIndex', $event)"
                @change-page="emit('changePage', $event)"
            />
            <product-details
                v-if="product.stock_state !== 2"
                :product="product"
                :also-like="alsoLike"
            />
        </v-card>
        <div v-if="product.stock_state === 2" id="alternative" class="pb-md-5">
            <product-alternatives-card v-if="product.alternatives.length" :product="product" />
        </div>
        <v-card
            v-if="product.stock_state === 2"
            elevation="0"
            :rounded="$vuetify.display.lgAndUp ? 'lg' : false"
        >
            <product-details :noMargin="true" :product="product" :also-like="alsoLike" />
        </v-card>
        <div id="recommended">
            <also-like v-if="alsoLike.length" :also-like="alsoLike"/>
        </div>
        <div id="alternative" v-if="product.stock_state !== 2">
            <product-alternatives-card v-if="product.alternatives.length" :product="product" />
        </div>
    </v-container>
</template>

<script setup>
import ProductQuickDetail from './ProductQuickDetail.vue';
import { computed, inject, ref, toRef, watch } from 'vue';
import { router, usePage } from '@inertiajs/vue3';
import ProductDetails from './ProductDetails.vue';
import { addEvent, generateItem } from '../../../../gtm.js';
import { useCartStore } from '../store/cart.js';
import { usePriceStore } from '../stores/price.js';
import pinia from '../../../../plugins/pinia.js';
import AlsoLike from './AlsoLike.vue';
import ProductAlternativesCard from './ProductAlternativesCard.vue';
import { getAdditionalVoc, getDiscountBase } from '../../../../utils/saleProcessor.js';

const store = usePriceStore(pinia);

const props = defineProps({
    product: Object,
    expedition: Number,
    alsoLike: {
        type: Array,
        default: [],
    },
    navigation: {
        type: Object,
        default: null,
    },
    dialog: Boolean
});

const emit = defineEmits(['changeIndex', 'changePage', 'close'])

const product = toRef(props, 'product');

watch(
    () => props.product.price,
    (val) => {
        if (!usePage().props.customer.id) {
            return;
        }
        if (val.includes('loading')) {
            const ids = [];
            if (props.alsoLike.length) {
                for (let i = 0; i < props.alsoLike.length; i++) {
                    if (store.prices[props.product.id]) {
                        props.product.price = store.prices[props.product.id].nice_price.replace('CZK', 'Kč');
                        props.product.price_no_vat = store.prices[props.product.id].nice_price_without_vat.replace('CZK', 'Kč');
                    } else {
                        ids.push(props.alsoLike[i].id);
                    }
                }
            }
            if (store.prices[props.product.id]) {
                product.value.discount_additional_voc = getAdditionalVoc(
                    store.prices,
                    props.product.id
                );
                product.value.discount_base = getDiscountBase(store.prices, props.product.id);
                product.value.price = store.prices[props.product.id].nice_price.replace(
                    'CZK',
                    'Kč'
                );
                product.value.price_no_vat = store.prices[
                    props.product.id
                    ].nice_price_without_vat.replace('CZK', 'Kč');
            } else {
                ids.push(props.product.id);
            }
            if (ids.length) {
                store.loadPricesFromApi(ids, usePage().props.customer.id).then((prices) => {
                    const length = ids.length;
                    for (let i = 0; i < length; i++) {
                        if (prices[props.product.id]) {
                            product.value.discount_additional_voc = getAdditionalVoc(
                                prices,
                                props.product.id
                            );
                            product.value.discount_base = getDiscountBase(prices, props.product.id);
                            product.value.price = prices[props.product.id].nice_price.replace(
                                'CZK',
                                'Kč'
                            );
                            product.value.price_no_vat = prices[
                                props.product.id
                                ].nice_price_without_vat.replace('CZK', 'Kč');
                        }

                        var a_product = props.alsoLike.find(p => p.id === ids[i]);
                        if (a_product && prices[a_product.id]) {
                            a_product.price = prices[a_product.id].nice_price.replace('CZK', 'Kč');
                            a_product.price_no_vat = prices[a_product.id].nice_price_without_vat.replace('CZK', 'Kč');
                        }
                    }
                });
            }
        }
    },
    { immediate: true }
);

const route = inject('route');

const cartStore = useCartStore(pinia);

const variant = ref(null);

const toAdd = ref(props.product.optimal_count_to_order);

const disabled = computed(() => {
    return false;
    // if (Array.isArray(product.value.variants)) {
    //     if (!product.value.variants.length) {
    //         return false;
    //     }
    // }
    // if (variant.value?.id) {
    //     return false;
    // }
    // return true;
});

const addToOrder = (count = 1) => {
    // eslint-disable-next-line no-undef
    router.post(
        route('order.addProduct'),
        { id_product: product.value.id, count, id_variant: variant.value?.id },
        {
            onSuccess: () => {
                const item = cartStore.cartItems.find((item) => {
                    if (variant.value?.id) {
                        return (
                            item.id_products == product.value.id &&
                            item.id_products_variants == variant.value.id
                        );
                    } else {
                        return item.id_products == product.value.id;
                    }
                });
                if (item) {
                    const price = parseFloat(item.nice_price.replace(/\s/g, '').replace(/,/g, '.'));
                    const attributes = {
                        quantity: count,
                        price: price.toFixed(2),
                    };
                    if (variant.value?.id) {
                        attributes.item_variant = variant.value.id;
                    }
                    addEvent({
                        event: 'add_to_cart',
                        ecommerce: {
                            currency: usePage().props.currency,
                            value: (price * count).toFixed(2),
                            items: generateItem(product.value, attributes),
                        },
                    });
                }
            },
        }
    );
};
</script>

<style scoped lang="scss">
::v-deep(.bottom-changer) {
    .v-btn--stacked {
        --v-btn-height: 48px;
    }
}

.cart-btn__border {
    &.v-btn--stacked {
        --v-btn-height: 50px;
    }
}

#recommended,
#alternative {
    &:before {
        content: '';
        display: block;
        height: 100px;
        margin: -100px 0 0;
    }
}
</style>
